var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconTimes = function SvgIconTimes(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.82 7.352 16.648 6.18 12 10.828 7.352 6.18 6.18 7.352 10.828 12 6.18 16.65l1.172 1.172L12 13.172l4.648 4.649 1.172-1.172L13.172 12z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconTimes);
export { ForwardRef as ReactComponent };